var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1643_29935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.3333C9.05228 10.3333 9.5 9.88554 9.5 9.33325C9.5 8.78097 9.05228 8.33325 8.5 8.33325C7.94772 8.33325 7.5 8.78097 7.5 9.33325C7.5 9.88554 7.94772 10.3333 8.5 10.3333Z",
    fill: "#C2C4C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 4.66667H11.1667V3.66667C11.1667 3.22464 10.9911 2.80072 10.6786 2.48816C10.366 2.17559 9.94207 2 9.50004 2H7.50004C7.05801 2 6.63409 2.17559 6.32153 2.48816C6.00897 2.80072 5.83337 3.22464 5.83337 3.66667V4.66667H3.83337C3.30294 4.66667 2.79423 4.87738 2.41916 5.25245C2.04409 5.62753 1.83337 6.13623 1.83337 6.66667V12C1.83337 12.5304 2.04409 13.0391 2.41916 13.4142C2.79423 13.7893 3.30294 14 3.83337 14H13.1667C13.6971 14 14.2058 13.7893 14.5809 13.4142C14.956 13.0391 15.1667 12.5304 15.1667 12V6.66667C15.1667 6.13623 14.956 5.62753 14.5809 5.25245C14.2058 4.87738 13.6971 4.66667 13.1667 4.66667ZM7.16671 3.66667C7.16671 3.57826 7.20183 3.49348 7.26434 3.43096C7.32685 3.36845 7.41163 3.33333 7.50004 3.33333H9.50004C9.58845 3.33333 9.67323 3.36845 9.73574 3.43096C9.79825 3.49348 9.83337 3.57826 9.83337 3.66667V4.66667H7.16671V3.66667ZM8.50004 11.6667C8.03855 11.6667 7.58742 11.5298 7.20371 11.2734C6.81999 11.017 6.52093 10.6526 6.34432 10.2263C6.16772 9.7999 6.12151 9.33074 6.21154 8.87812C6.30157 8.4255 6.5238 8.00974 6.85012 7.68342C7.17645 7.35709 7.59221 7.13487 8.04483 7.04483C8.49745 6.9548 8.96661 7.00101 9.39297 7.17761C9.81933 7.35422 10.1837 7.65329 10.4401 8.037C10.6965 8.42072 10.8334 8.87184 10.8334 9.33333C10.8334 9.95217 10.5875 10.5457 10.15 10.9832C9.71237 11.4208 9.11888 11.6667 8.50004 11.6667Z",
    fill: "#C2C4C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1643_29935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileCamera);
export default __webpack_public_path__ + "static/media/icon_profile_camera.492a8107961e9a6cd346d74a47875745.svg";
export { ForwardRef as ReactComponent };